import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { DurationFilterComponent } from '@/scopes/search/components/DurationFilterComponent'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { QuickSearchFilterProps } from '@/scopes/search/search/pages/SearchPage/components/QuickSearchFilters/types'
import * as React from 'react'
import { createSearchFilterClickEvent } from '../../../../domain/analytics'

export function DurationQuickSearchItemFilter({ id, icon, isCollapsed }: QuickSearchFilterProps) {
  const { sendEvent } = useAnalytics()
  const { options, isFetching, setSelection, selectedOptions } = useMultiSelectFilter('Duration')

  const handleConfirm = (selection: string[]) => {
    if (!isFetching) {
      setSelection(selection)

      if (selection.length) {
        sendEvent(
          createSearchFilterClickEvent({
            element: 'checkbox',
            type: 'duration',
            result: selection.join(','),
          }),
        )
      }
    }
  }

  return (
    <DurationFilterComponent
      onConfirm={handleConfirm}
      options={options}
      selectedOptions={selectedOptions}
      disabled={isFetching}
      id={id}
      icon={icon}
      isCollapsed={isCollapsed}
    />
  )
}
